import * as Yup from "yup";

const SPECIAL_CHARS = `~\`!@#\\$%\\^&\\*\\(\\)_\\+\\-=\\[\\]\\{\\}\\\\|;:'‘"“,<.>\\/\\? ñÑ∙`;
const NAME_SPECIAL_CHARS = 'Ññ .-';
const FIELD_REQUIRED_MSG = "This field is required";
const MAX_NUM = "The max. no of characters is";
const MIN_NUM = "The min. no of characters is";
const FIELD_INVALID = "Please provide a valid value";
const MOBILE_NUM_FIRST = "Please enter valid mobile number";
const MOBILE_NUM_LENGTH = "Mobile number must contain 10 digits";
//const EMAIL_FORMAT_REGEX = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
const STRICT_EMAIL_REGEX = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
const EMAIL_CHAR_REGEX = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.@-]+$/;
const ALLOWED_KEYS = ["Backspace", "Tab", "Escape", "Delete", "ArrowLeft", "ArrowRight", "Home", "End"];

const customerSchema = Yup.object().shape({
	firstName: Yup.string()
		//    UNCOMMENT THIS IF REQUIRED FIELD IS NEEDED
		// .test("required-first", FIELD_REQUIRED_MSG, (value) => {
		// 	if (!value || value.trim() === "") return false;
		// 	return true;
		// })
		.test("valid-first-special-chars", FIELD_INVALID, (value) => {
			if (!value) return true;
			return new RegExp(`^[A-Za-z${NAME_SPECIAL_CHARS}]+$`).test(value);
		})
		.test("min-length", `${MIN_NUM} 2`, (value) => {
			if (!value) return true;
			return value.length >= 2;
		})
		.test("max-length", `${MAX_NUM} 100`, (value) => {
			if (!value) return true;
			return value.length <= 100;
		}),

	middleInitial: Yup.string()
		.test("valid-middle-initial-chars", FIELD_INVALID, (value) => {
			if (!value) return true;
			return new RegExp(`^[A-Za-z]+$`).test(value);
		})
		.test("max-length", `${MAX_NUM} 2`, (value) => {
			if (!value) return true;
			return value.length <= 2;
		})
		.nullable(),

	lastName: Yup.string()
		//    UNCOMMENT THIS IF REQUIRED FIELD IS NEEDED
		// .test("required-first", FIELD_REQUIRED_MSG, (value) => {
		// 	if (!value || value.trim() === "") return false;
		// 	return true;
		// })
		.test("valid-last-special-chars", FIELD_INVALID, (value) => {
			if (!value) return true;
			return new RegExp(`^[A-Za-z${NAME_SPECIAL_CHARS}]+$`).test(value);
		})
		.test("min-length", `${MIN_NUM} 2`, (value) => {
			if (!value) return true;
			return value.length >= 2;
		})
		.test("max-length", `${MAX_NUM} 100`, (value) => {
			if (!value) return true;
			return value.length <= 100;
		}),

	suffix: Yup.string()
		.test("max-length", `${MAX_NUM} 3`, (value) => {
			if (!value) return true;
			return value.length <= 3;
		})
		.nullable(),

	emailAddress: Yup.string()
		.test("valid-email", FIELD_INVALID, (value) => {
			if (!value) return true; // optional
			return STRICT_EMAIL_REGEX.test(value);
		})
		.test("max-length", `${MAX_NUM} 100`, (value) => {
			if (!value) return true;
			return value.length <= 100;
		})
		.nullable(),

	mobileNumber: Yup.string()
		.test("starts-with-9", MOBILE_NUM_FIRST, (value) => {
			if (!value) return true;
			return /^9/.test(value);
		})
		//    UNCOMMENT THIS IF REQUIRED FIELD IS NEEDED
		// .test("required-first", FIELD_REQUIRED_MSG, (value) => {
		// 	if (!value || value.trim() === "") return false;
		// 	return true;
		// })
		.test("exact-10-digits", MOBILE_NUM_LENGTH, (value) => {
			if (!value) return true;
			return /^\d{10}$/.test(value);
		}),

	address: Yup.string()
		//    UNCOMMENT THIS IF REQUIRED FIELD IS NEEDED
		// .test("required-first", FIELD_REQUIRED_MSG, (value) => {
		// 	if (!value || value.trim() === "") return false;
		// 	return true;
		// })
		.test("valid-address", FIELD_INVALID, (value) => {
			if (!value) return true;
			return new RegExp(`^[A-Za-z0-9${SPECIAL_CHARS}]+$`).test(value);
		})
		.test("min-length", `${MIN_NUM} 5`, (value) => {
			if (!value) return true;
			return value.length >= 5;
		})
		.test("max-length", `${MAX_NUM} 100`, (value) => {
			if (!value) return true;
			return value.length <= 100;
		}),
});

export const keyDownValidation = {
	mobileNumber: (e) => {
		if ([46, 9, 27, 13, 8].findIndex((v) => v == e.keyCode) !== -1 || (e.keyCode >= 96 && e.keyCode <= 105)) {
			return;
		}
		var charValue = String.fromCharCode(e.keyCode),
			valid = /^[0-9]+$/.test(charValue);
		if (!valid || e.shiftKey == true) {
			e.preventDefault();
		}
	},
  	alphabetOnly: (e) => {
		if (ALLOWED_KEYS.includes(e.key) || e.ctrlKey || e.metaKey) {
			return;
		}
		const regex = new RegExp(`^[A-Za-z]+$`);
		if (!regex.test(e.key)) {
			e.preventDefault();
		}
	},
	alphaNameSpecialCharSpace: (e) => {
		if (ALLOWED_KEYS.includes(e.key) || e.ctrlKey || e.metaKey) {
			return;
		}
		const regex = new RegExp(`^[A-Za-z${NAME_SPECIAL_CHARS}]$`);
		if (!regex.test(e.key)) {
			e.preventDefault();
		}
	},
  	alphaNumSpecialCharSpace: (e) => {
		if (ALLOWED_KEYS.includes(e.key) || e.ctrlKey || e.metaKey) {
			return;
		}
		const regex = new RegExp(`^[A-Za-z0-9${SPECIAL_CHARS}]$`);
		if (!regex.test(e.key)) {
			e.preventDefault();
		}
	},
	validEmailAddress: (e) => {
		if (ALLOWED_KEYS.includes(e.key) || e.ctrlKey || e.metaKey) {
			return;
		}
		// Only allow characters valid in an email address
		if (!EMAIL_CHAR_REGEX.test(e.key)) {
			e.preventDefault();
		}
	},
	omitSpace: (e) => {
		if (e.key === " " || e.key === "Spacebar") {
			e.preventDefault();
		}
	},
	preventPaste: (e) => {
		e.preventDefault();
	},
	preventCopy: (e) => {
		e.preventDefault();
	},
};

export default customerSchema;
